export default __webpack_public_path__ + "f7554bf7b34a6ca27446bb5f302a4979.svg";